// extracted by mini-css-extract-plugin
module.exports = {"componentsButton":"styles_componentsButton__2Zg4O","move":"styles_move__3hbfB","scaleDrew":"styles_scaleDrew__3Hwue"};